import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../Store';
import styles from '../auth.module.scss';
import {
    setEmail
} from '../Slice/CreateAccountSlice';
import { setCreateAccountVisible, setLoginVisible } from '../Slice/DialogSlice';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRegisterMutation } from '../api/ProfileAPI';

/**
 * @author noone
 */
export default function AuthDialogSignUp() {

    const visible = useSelector((state: RootState) => state.authReducer.dialog.createAccountVisible);
    const newProfile = useSelector((state: RootState) => state.authReducer.authCreate.profile);
    const [passwordRepeat, setPassWordRepeat] = useState<string>();
    const [approval, setApproval] = useState<boolean>(false);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate()
    const { t } = useTranslation();
    const apiUrl = process.env.REACT_APP_API_URL;
    const [registerAPI] = useRegisterMutation();

    const headerElement = (
        <div>
            <div>
                <h3 style={{ textAlign: 'center' }}>{ t('deTranslation.dialogRegister.headline') } </h3>
            </div>
            <div style={{ textAlign: 'center' }}>{ t('deTranslation.dialogRegister.alredyAccount') }
                <a href="#" style={{ color: '#FF631C', textDecoration: 'none' }} onClick={() => {
                    dispatch(setLoginVisible(true));
                    dispatch(setCreateAccountVisible(false));
                }}>&nbsp;{ t('deTranslation.dialogRegister.logInHere') }</a>
            </div>
        </div>
    );

    const footerContent = (
        <div>
            
            <div>
                <p style={{ marginTop: '50px' }}>
                    { t('deTranslation.dialogRegister.byClicking') }
                </p>
            </div>

            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <Button
                    type="submit"
                    //disabled={!approval}
                    onClick={(event) => {
                        event.preventDefault();

                        {
                            registerAPI({email: newProfile.email , password: newProfile.password}).unwrap()
                            .then( () => {
                                dispatch(setCreateAccountVisible(false));
                            })
                            .catch(error => {alert('Es ist ein Fehler aufgetreten' + error)});
                        }
                        
                    }}

                > { t('deTranslation.dialogRegister.createAccount') }
                </Button>
               
            </div>
        </div>

    );

    /*
     <div style={{ textAlign: 'center', marginTop: '50px' }}>
                    <a href="/contact" style={{ color: '#FF631C', textDecoration: 'none' }} >Contact Küchenapp</a>
                </div>

                */

    /*
    <div style={{ height: '90px', columnGap: '1em', 'alignItems': 'center', display: 'grid', 'gridTemplateColumns': '1fr 1fr 1fr' }}>
                    </div>  
      */


                    /*

                    <div style={{ marginTop: '10px' }}>
                        <label>Password: <span style={{ color: '#FF631C' }}>*</span></label>
                        <div>
                            <Password
                                value={newProfile.password}
                                onChange={(event) => {
                                    dispatch(setPassWord(event.target.value))
                                }}
                                toggleMask
                                tabIndex={1}
                            />
                        </div>
                    </div>

                    <div style={{ marginTop: '10px' }}>
                        <label>Password Repeat: <span style={{ color: '#FF631C' }}>*</span></label>
                        <div>
                            <Password
                                // className={classNames(passwordRepeat !== newProfile.password ? 'p-invalid' : 'p-inputtext')}
                                value={passwordRepeat}
                                onChange={(event) => {
                                    setPassWordRepeat(event.target.value)
                                }}
                                toggleMask
                                feedback={false}
                                tabIndex={2}
                            />
                        </div>
                    </div>
                    */

    return (
        <Dialog
            header={headerElement}
            footer={footerContent}
            visible={visible}
            onHide={
                () => dispatch(setCreateAccountVisible(false))
            }
        >
            <div>
                <form className="form flex-col" onSubmit={() => { }}>
                    <div style={{ marginTop: '10px' }}>
                        <label>{ t('deTranslation.dialogRegister.inputEmail') }<span style={{ color: '#FF631C' }}>*</span></label>
                        <div>
                            <InputText
                                className={classNames(!newProfile?.email ? 'p-invalid' : 'p-inputtext')}
                                id='input-email'
                                type='text'
                                value={newProfile?.email || ''}
                                onChange={(event: any) => dispatch(setEmail(event.target.value))}
                            />
                        </div>
                    </div>

                </form>
            </div>
        </Dialog>
    );
}